import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-ivory py-20" aria-labelledby="faq-title" data-id="element-45" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-46" data-mp="1ccdnwo55bito">
        <SectionHeading id="faq-title" tone="onLight" data-id="element-47" data-mp="2a2icelvuq6qz">Domande <span className="text-gold-dark" data-id="element-48" data-mp="2a05uu9u09yeg">frequenti</span></SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-49" data-mp="253oyiscnkdqa">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-xl border bg-white/70 transition-colors duration-150 ease-out ${isOpen ? 'border-gold' : 'border-ivory-dark'}`} data-id="element-50" data-mp="1v5839j6olcyf" data-mpi={index}>
                <h3 className="font-sans" data-id="element-51" data-mp="jpsw5mkrd4pl">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-navy transition-colors duration-150 ease-out hover:bg-ivory-dark/40 focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-gold/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-52" data-mp="jorhl84ja034">
                    <span data-id="element-53" data-mp="1fodogc7rp8pt">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-54" data-mp="1fn2ge07ahesw" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="16q1y8batccxw">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-56" data-mp="s0dvr6qwb88l">
                      <p className="border-t border-ivory-dark px-5 py-4 leading-relaxed text-navy/80 sm:px-6" data-id="element-57" data-mp="2pmwshdi5br2o">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}